<template>
  <div class="w-[420px] operation-wrap">
    <div
      v-if="!isGlobalVersion()"
      class="login-mode-switcher"
      @click="onChangeLoginModeClick"
    >
      <div class="radian"></div>
      <a-tooltip
        :title="loginMode === 'pwd' ? '微信登录' : '手机号/账号登录'"
        placement="bottom"
      >
        <iconpark-icon v-if="loginMode === 'pwd'" name="scan-login" />
        <iconpark-icon v-else name="pwd-login"></iconpark-icon>
      </a-tooltip>
    </div>
    <WechatLogin
      v-if="status === 'login' && loginMode === 'wechat'"
      @success="$emit('next')"
      @accountSelect="onSelectAccount"
    ></WechatLogin>
    <AccountLogin
      v-if="status === 'login' && loginMode === 'pwd'"
      @back="status = 'resetPwd'"
      @success="$emit('next')"
      @accountSelect="onSelectAccount"
    />
    <SelectAccount v-model:open="open" @select="onSelect" />
    <AccountResetPwd v-if="status === 'resetPwd'" @back="status = 'login'" />
  </div>
</template>
<script lang="ts" setup>
import AccountLogin from '~/features/account/login/base'
import AccountResetPwd from '~/features/account/reset/base.vue'
import WechatLogin from '~/features/account/login/wechatLogin.vue'
import SelectAccount from '~/features/account/select/selectModal.vue'
import { emitter, EVENT } from '~/utils/eventbus'

type Status = 'login' | 'resetPwd'

const emit = defineEmits(['next'])

// 登录方式
type LoginMode = 'pwd' | 'wechat'

const loginMode = ref<LoginMode>(isChinese() ? 'wechat' : 'pwd')

function onChangeLoginModeClick() {
  loginMode.value = loginMode.value === 'pwd' ? 'wechat' : 'pwd'
}

const status = ref<Status>('login')

onMounted(() => {
  emitter.on(EVENT.SWITCH_WECHAT_LOGIN, () => (loginMode.value = 'wechat'))
  emitter.on(EVENT.FIND_PWD, () => (status.value = 'resetPwd'))
})
const open = ref(false)

function onSelect() {
  emit('next')
  open.value = false
}

function onSelectAccount() {
  open.value = true
}
</script>
<style lang="scss" scoped>
.operation-wrap {
  position: relative;
  padding: 70px 90px 40px;
  width: 600px;
  background: var(--login-operation-bg);
  border-radius: 20px;
  border: 1px solid var(--back-3);
}
.login-mode-switcher {
  position: absolute;
  right: 0;
  top: 0;
  width: 79px;
  height: 76px;
  cursor: pointer;

  &::after,
  &::before {
    position: absolute;
    content: ' ';
    width: 0;
    height: 0;
    right: 0;
    bottom: 0;
  }
  &::after {
    // 左下角白色三角形
    border-top: 76px solid transparent;
    border-right: 0 solid transparent;
    border-left: 79px solid var(--login-operation-bg);
    pointer-events: none;
  }
  &::before {
    // 右上角蓝色三角形
    border-bottom: 76px solid transparent;
    border-left: 0 solid transparent;
    border-right: 79px solid var(--purple-1);
  }
  iconpark-icon {
    position: absolute;
    font-size: 27px;
    color: var(--primary-color);
    right: 15px;
    top: 15px;
  }
}
</style>
